<nz-range-picker
  [nzSize]="'large'"
  [ngModel]="dateList"
  (ngModelChange)="onStartEndChange($event)"
  (nzOnCalendarChange)="onCalendarChange($event)"
  [nzDisabledDate]="disabledDate"
></nz-range-picker>
<button nz-button [nzType]="isAllTimeType" nzSize="small" (click)="onAllTimeClick()" *ngIf="showAllTimeButton">
  <span nz-icon style="font-size: 16px" class="material-symbols-rounded">schedule</span>
  All Time
</button>
